export const accountSetup = {
  payments: {
    planUnavailableTitle: "In Ihrem Tarif nicht verfügbar",
    planUnavailableMessage:
      "Gästezahlungen über Stripe sind erst ab dem Tarif Standard verfügbar. Upgraden Sie Ihren Tarif, um die Funktion freizuschalten und Zahlungen direkt ohne Zwischenhändler zu kassieren.",
  },
  modalConnection: {
    header: "PMS verbinden",
    loaderMessage: "Wird gespeichert, bitte warten.",
    selectPmsLabel: "PMS-System auswählen",
    selectPmsPlaceholder: "PMS auswählen",
    apiKeyLabel: "{pms} API Key",
    apiKeyPlaceholder: "Geben Sie Ihren API Key ein",
    cancel: "Abbrechen",
    save: "Verbindung speichern",
    fieldRequired: "Pflichtfeld",
    selectPmsError: "Wählen Sie ein PMS",
    apiKeyError: "Bitte geben Sie den API Key ein",
    savedTitle: "Verbindung gespeichert",
    savedMessage: "Die Verbindung wurde erfolgreich gespeichert",
    saveFailMessage: "Die Verbindung konnte nicht gespeichert werden",
    errorTitle: "Fehler",
    serverError: "Fehler bei der Verbindung zum Server",
  },
  subscription: {
    title: "Mein Abonnement",
    subtitle: "Sehen und verwalten Sie Ihren Tarif, Ihre Zahlungsart und Ihre Rechnungen.",
    statusActive: "Aktiv",
    // Cancelada pero todavía dentro de lo que ya pagó: ni «Activa» ni «Cancelada» a secas.
    statusCanceledValid: "Gekündigt · aktiv bis",
    validUntil: "Aktiv bis:",
    statusPaymentPending: "Zahlung ausstehend",
    statusTrial: "Testphase",
    statusNone: "Kein aktives Abonnement",
    intervalYearly: "Jahrestarif",
    intervalMonthly: "Monatstarif",
    perMonthShort: "/Mon.",
    nextRenewal: "Nächste Verlängerung:",
    servicesIncluded: "Enthaltene Leistungen",
    units: "Einheit | Einheiten",
    perUnitSuffix: "/Einheit",
    serviceFallback: "Leistung",
    manageOpening: "Wird geöffnet…",
    manageButton: "Abonnement und Rechnungen verwalten",
    emptyText:
      "Sie haben noch keinen aktiven Tarif. Wählen Sie einen, um Check-ins und Zahlungen zu erhalten.",
    buyPlan: "Tarif kaufen",
    types: {
      apartment: "Apartment",
      hotel: "Hotel",
      room: "Zimmer",
      camping: "Camping",
      villa: "Villa",
      chatbot: "KI-Rezeption",
    },
  },
  purchased: {
    title: "In Ihrem Abonnement verfügbar",
    subtitle: "Gebuchtes Kontingent und aktuelle Nutzung",
    accommodations: "Unterkünfte",
    empty: "Sie haben noch keine Unterkünfte angelegt.",
    createProperty: "Unterkunft anlegen",
    adjust: "Anpassen",
    loadError: "Die Informationen konnten nicht geladen werden.",
    labels: {
      apartment: "Apartment(s)",
      hotel: "Hotel (Zimmer)",
      hotelPack: "Hotel (Zimmer) · #{id}",
      villa: "Villen",
      camping: "Campingplätze",
      campingPack: "Campingplätze · #{id}",
      chatbot: "Chatbot-Lizenzen",
    },
    units: {
      unid: "Einheiten",
      room: "Zimmer",
      spots: "Stellplätze",
      licenses: "Lizenzen",
    },
    types: {
      hotel: "Hotel",
      camping: "Camping",
      villa: "Villa",
      apartment: "Apartment",
    },
    badge: {
      rooms: "{n} Zimmer",
      spots: "{n} Stellplätze",
      unit: "1 Einheit",
    },
  },
  notifications: {
    title: "Benachrichtigungen",
    description: "Aktivieren oder deaktivieren Sie Nachrichten-Automatisierungen und Hinweise.",
    loading: "Einstellungen werden geladen...",
    alwaysActive: "Immer an",
    active: "An",
    inactive: "Aus",
    hint:
      "Hinweis: Einige Automatisierungen werden nur informativ angezeigt, weil sie bereits zum Standardablauf des Systems gehören.",
    loadError: "Die Einstellungen konnten nicht geladen werden.",
    saveError: "Die Änderung konnte nicht gespeichert werden. Neuer Versuch...",
    items: {
      whatsapp_booking_confirmation: {
        title: "Buchungsbestätigung (WhatsApp)",
        description:
          "Sendet automatisch die Bestätigungsvorlage, wenn eine Buchung bestätigt wird.",
      },
      email_checkin_sent: {
        title: "E-Mail-Benachrichtigungen beim Senden des Check-ins",
        description:
          "Sendet eine automatische E-Mail, wenn der Check-in abgeschlossen oder gesendet wird.",
      },
      whatsapp_checkin_link_auto: {
        title: "Automatisches WhatsApp für den Online-Check-in senden",
        description:
          "Sendet den Link zum Online-Check-in bei Bedarf automatisch per WhatsApp.",
      },
      checkin_link_send_policy: {
        title: "Regel für den Versand des Check-in-Links bei Direktbuchungen",
        description:
          "Legen Sie fest, ob der Link immer gesendet wird oder nur, wenn die Buchung ganz oder teilweise bezahlt ist.",
        options: {
          always: {
            label: "Immer senden",
            description:
              "Sendet den Check-in-Link unabhängig vom Zahlungsstatus.",
          },
          paid_or_partially_paid: {
            label: "Nur bezahlt oder teilweise bezahlt",
            description:
              "Sendet den Link nur, wenn die Buchung ganz oder teilweise bezahlt ist. Gilt nur für Direktbuchungen.",
          },
        },
      },
    },
  },
  wompi: {
    country: "Kolumbien",
    statusVerified: "Verbunden",
    statusPending: "Nicht verifiziert",
    publicKeyLabel: "Public Key",
    privateKeyLabel: "Private Key",
    keepPrivateLabel: "Gespeicherten Private Key beibehalten (aus Sicherheitsgründen ausgeblendet)",
    privatePlaceholderSaved: "•••••••••••• (gespeichert)",
    btnDisconnect: "Trennen",
    btnVerify: "Konto verifizieren",
    btnSave: "Zugangsdaten speichern",
    merchantHeader: "Händler erkannt",
    missingPublicKey: "Public Key fehlt",
    missingPrivateKey: "Private Key fehlt",
    savedOk: "Zugangsdaten erfolgreich gespeichert",
    saveError: "Fehler beim Speichern der Zugangsdaten",
    verifiedOk: "Konto verifiziert",
    notVerified: "Konto nicht verifiziert",
    verifyError: "Fehler beim Verifizieren des Kontos",
    disconnectConfirm: "Möchten Sie Wompi wirklich von diesem Unternehmen trennen?",
    disconnectedOk: "Erfolgreich getrennt",
    disconnectError: "Fehler beim Trennen",
  },
  pricelabs: {
    subtitle: "Dynamische Preisoptimierung",
    statusConnected: "Verbunden",
    statusDisconnected: "Nicht verbunden",
    loading: "Einstellungen werden geladen...",
    emailLabel: "PriceLabs E-Mail",
    emailPlaceholder: "ihre-email@pricelabs.com",
    importantTitle: "Wichtig:",
    bullet1: "Stellen Sie sicher, dass Ihre Unterkünfte vollständig eingerichtet sind",
    bullet2: "Neue Unterkünfte werden automatisch synchronisiert",
    bullet3:
      "Die Preise werden gemäß PriceLabs aktualisiert und können in Wacheckin nicht manuell bearbeitet werden",
    btnConnect: "Verbinden und synchronisieren",
    btnConnecting: "Wird verbunden...",
    btnSync: "Synchronisieren",
    btnSyncing: "Wird synchronisiert...",
    btnDisconnect: "Trennen",
    btnDisconnecting: "Wird getrennt...",
    emailRequired: "Bitte geben Sie Ihre PriceLabs E-Mail ein",
    emailRequiredTitle: "E-Mail erforderlich",
    connectHeader: "Mit PriceLabs verbinden?",
    connectMessage:
      "Alle Ihre aktiven Unterkünfte und Zimmer werden verknüpft. Tarife und Verfügbarkeit werden synchronisiert. Später angelegte Unterkünfte/Zimmer werden automatisch übertragen.",
    connectAccept: "Ja, verbinden",
    cancel: "Abbrechen",
    linkError: "Fehler beim Verknüpfen der Einheiten",
    emailNotFoundConnect:
      "PriceLabs meldet, dass die E-Mail nicht existiert. Prüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
    emailInvalidTitle: "Ungültige PriceLabs E-Mail",
    syncSuccess: "Ihre Unterkünfte sind jetzt mit PriceLabs verbunden.",
    syncSuccessTitle: "Synchronisierung abgeschlossen!",
    syncFail: "Die Synchronisierung konnte nicht abgeschlossen werden",
    errorTitle: "Fehler",
    emailNotFoundManual:
      "PriceLabs gibt an, dass die E-Mail nicht existiert. Korrigieren Sie die E-Mail und synchronisieren Sie erneut.",
    manualSuccess: "Der Vorgang wurde erfolgreich abgeschlossen.",
    manualSuccessTitle: "Manuelle Synchronisierung",
    manualFail: "Die Synchronisierung mit PriceLabs war nicht möglich",
    disconnectHeader: "PriceLabs trennen?",
    disconnectMessage: "Alle Ihre Unterkünfte werden von PriceLabs getrennt.",
    disconnectAccept: "Ja, trennen",
    disconnectedOk: "Ihr Konto wurde von PriceLabs getrennt",
    disconnectedTitle: "Getrennt",
    disconnectFail: "Die Trennung von PriceLabs war nicht möglich",
    noErrorsReported: "Keine Fehler gemeldet.",
    listingPrefix: "Inserat {id}: ",
    unknownError: "Unbekannter Fehler",
    listTitle: "Welche Inserate gehen an PriceLabs",
    listHint: "Wähle, welche PriceLabs verwalten soll. Die ausgeschalteten behalten ihre Preise und du änderst sie selbst.",
    listCount: "{n} von {total} ausgewählt",
    listSearch: "Unterkunft oder Zimmer suchen…",
    listRooms: "{n} Zimmer",
    listApartment: "Apartment",
    listEmpty: "Du hast noch keine Unterkünfte.",
    listNoMatch: "Keine Unterkunft mit diesem Namen.",
    listNeedsCurrency: "Währung fehlt",
    listNeedsRate: "Preisplan fehlt",
    btnConnectN: "Verbinden und synchronisieren | Verbinden und {n} synchronisieren | Verbinden und {n} synchronisieren",
    unitConnected: "{name} geht jetzt an PriceLabs",
    unitDisconnected: "{name} geht nicht mehr an PriceLabs",
    unitFail: "Konnte nicht geändert werden. Bitte erneut versuchen.",
    listLocked: "Verbinde dein PriceLabs-Konto und du kannst hier wählen, welche Inserate es verwaltet.",
    listAll: "Alle",
    listNone: "Keine",
    btnSyncN: "Synchronisieren | 1 Inserat synchronisieren | {n} Inserate synchronisieren",
    connectedOk: "Konto verbunden. Wähle jetzt, welche Inserate an PriceLabs gehen.",
    connectedTitle: "Fertig",
  },
};
